import { Platform } from "react-native";

/**
 * Stroke widths on the board are screen pixels. The default keeps them fixed
 * with vectorEffect="non-scaling-stroke", so a camera scale never thickens
 * or thins a line. If non-scaling-stroke misbehaves on a platform (Android is
 * the usual suspect), flip it here: the fallback passes width x unitsPerPx in
 * board units, which draws the same pixels.
 */
export const USE_NON_SCALING_STROKE = Platform.select({
  android: true,
  default: true,
});

export function strokeWidthProps(
  widthPx: number,
  unitsPerPx = 1,
): { strokeWidth: number; vectorEffect?: "non-scaling-stroke" } {
  return USE_NON_SCALING_STROKE
    ? { strokeWidth: widthPx, vectorEffect: "non-scaling-stroke" }
    : { strokeWidth: widthPx * unitsPerPx };
}
